import "babel-polyfill"
import Vue from 'vue'
import App from './App'
import router from './router'
import vueI18n from './plugins/i18n'
import store from './store'
import storage from 'storejs'
import filters from './plugins/filters'
import iviewModule from './plugins/iview';
import 'view-design/dist/styles/iview.css';
import 'iview/dist/styles/iview.css';
import './style/myview.scss';
import common from './until/until.js'
import VueLazyload from 'vue-lazyload'
const lazyIMG = require('@/assets/loading_v_empty.png')
Vue.use(VueLazyload,{
  loading:lazyIMG, // 加载中图片
  preLoad: 1.3,//lazyload的元素,距离页面底部距离的百分比，计算值为(preload - 1)，默认值为1.3
	error: lazyIMG,//加载失败的图片
	attempt: 1//尝试次数
})

import confirmModal from "./until/MultiplePopup.js"
Vue.use(confirmModal)
// 复制到粘贴板插件
import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

Object.keys(iviewModule).forEach(key => {
  Vue.component(key, iviewModule[key]);
  if(key == "iMessage"){
    Vue.prototype.$Message=iviewModule[key]
  }
  if(key == "LoadingBar"){
    Vue.prototype.$Loading=iviewModule[key]
  }
  if(key == "Modal"){
    Vue.prototype.$Modal=iviewModule[key]
  }
});
Vue.prototype.$Loading.config({
    color: '#6FBF59',
    failedColor: '#f0ad4e',
    height: 2
});
Vue.prototype.$Message.config({
  top: 350,
  duration: 3
});

Object.keys(filters).forEach(filterName => {
  Vue.filter(filterName, filters[filterName])
});


Vue.prototype._i18n = vueI18n;
Vue.prototype.$store = store;
Vue.prototype.$storage = storage;
Vue.prototype.eventBus = new Vue();
Vue.prototype.common = common;
Vue.config.productionTip = false;
Vue.config.errorHandler = function (err, vm, info) {
  console.error(err, info);
  return true
};
new Vue({
  el: '#app',
  router,
  vueI18n,
  store,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js